import styled from "styled-components";
import { useNavigate, } from 'react-router-dom';



const Container=styled.div`
	display:flex;
	position:relative;
	transition: scale 500ms;
	justify-content:center;
	align-items:center;
	text-align:center;
	height:101%;
	background-size:cover;
	background-position-x:center;
	transform: skew(-11deg); 
	overflow:hidden;
	&:hover{
		scale:1.02
	};
	@media (max-width:900px) {
    	transform: skew(0deg);
    	width:100vw;
    
  	};

`;


 const Efecto=styled.div`
	transition: all 500ms;
	position:absolute;
	display:flex;
	justify-content:center;
	align-items:center;
	height:100%;
 	width:100%; 		
 	&:hover{
 		background-color:black;
 		opacity:0.3;
 	} `;

 const Texto=styled.div`
 	transition: all 500ms;
 	position:absolute;
 	display:flex;
 	align-items:center;
 	font-family: 'Poppins', sans-serif;
 	font-size:30px;
 	opacity:1;
 	color:orange;
 	height:8%;
 	z-index:5;	
 	
 	`;
 const Fondo=styled.img`
 		transform: skew(11deg); 
 		height:100%;
 		@media (max-width:900px) {
    			transform: skew(0deg);
  		};

 		 `;

export default function Ruta(props){
	let navigate=useNavigate();

	let goToSteps=()=>{
		navigate(`/Home/Tutoriales/pasos/${props.ruta}`)
	}
		
	return(
		<Container onClick={goToSteps} >
			<Fondo src={`${props.rutaImg}`}  />
			<Texto ><b>{props.texto}</b></Texto>
			<Efecto/>
		</Container>


		)
}